export default {
	'visit-$-date-for-$-entity-changed-to-$': 'Visit of {date} for {entity} changed to {newVal}',
	'visit-$-entity-for-$-date-changed-to-$': 'Visit of {entity} for {date} changed to {newVal}',
	'click-to-view-the-new-plan': 'Click To View The New Plan',
	'no-notifications': 'No notifications',
	'mark-all-as-read': 'Mark all as read'
}